'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Box = require('../../../../../../../../common/components/layout/Box/Box.js');
var ItemCard_module = require('./ItemCard.module.css.js');
var ProductThumbnail = require('@narvar/nth-block-product-thumbnail');
var ItemCardItemDetails = require('./ItemCardItemDetails.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ProductThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(ProductThumbnail);

const PackageClaimTypeItemCard = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "li",
    gap: 2,
    key: item.sku,
    className: ItemCard_module["default"].item
  }, /*#__PURE__*/React__default["default"].createElement(ProductThumbnail__default["default"], {
    productInfo: {
      imageUrl: item.itemImage,
      name: item === null || item === void 0 ? void 0 : item.name
    },
    s: {
      margin: 0
    }
  }), /*#__PURE__*/React__default["default"].createElement(ItemCardItemDetails["default"], {
    item: item
  }));
};

exports["default"] = PackageClaimTypeItemCard;
